module.exports = __webpack_public_path__ + "imgs/leafwell4.1f14d0d29f9861a6d92c2140d8120ee4.svg";